import { render } from "./gsrbr0401.vue?vue&type=template&id=f3543646&scoped=true"
import script from "./gsrbr0401.vue?vue&type=script&lang=js"
export * from "./gsrbr0401.vue?vue&type=script&lang=js"

import "./gsrbr0401.vue?vue&type=style&index=0&id=f3543646&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3543646"]])

export default __exports__